<template>
  <div
    class="main"
    style="overflow-x: hidden; overflow-y: hidden;"
    :class="{ nowebp: !supportwebp }"
  >
    <!-- 弹框视频 -->
    <div
      class="model"
      :class="{ show: showVideo }"
      @touchmove="preventMove($event)"
    >
      <div class="model-content">
        <div class="model-detail">
          <div id="videobox" :style="autoFixVideoStyle"></div>
        </div>
        <div
          class="model-close"
          :style="{ cursor: 'pointer' }"
          @click="closeVideo"
        ></div>
      </div>
    </div>
    <!-- 弹框视频 -->
    <div class="logo_switch_top">
      <a href="/">Nintendo Switch</a>
    </div>
    <div class="globalNavigation">
      <div class="globalNavigation__logo">
        <a
          class="globalNavigation__logo__btn"
          href="javascript:void(0);"
          target="blank"
          rel="noreferrer noopener"
          @click="jump('https://www.ubisoft.com.cn/', true)"
        >
          <svg
            role="img"
            class="icon icon-ubisoft-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="80"
            viewBox="0 0 106 32"
            aria-labelledby="globalNavigationTitle globalNavigationDesc"
          >
            <title id="globalNavigation__title">Ubisoft Logo</title>
            <desc id="globalNavigation__desc">
              An illustrated Ubisoft logo with Ubisoft title
            </desc>
            <path
              fill="#fff"
              style="fill: var(--color1, #fff);"
              d="M31.401 16.15c-0.342-16.178-21.856-22.213-30.145-7.048 0.371 0.271 0.87 0.628 1.241 0.885-0.628 1.327-1.056 2.682-1.284 4.037-0.157 0.885-0.243 1.798-0.243 2.725 0 8.389 6.819 15.208 15.222 15.208s15.208-6.805 15.208-15.208c0-0.2 0-0.399 0-0.599zM4.722 18.86c-0.2 1.641-0.071 2.154-0.071 2.354l-0.371 0.128c-0.143-0.271-0.485-1.227-0.642-2.511-0.399-4.893 2.939-9.302 8.032-10.129 4.665-0.685 9.131 2.211 10.172 6.263l-0.371 0.128c-0.114-0.114-0.3-0.442-1.013-1.156-5.635-5.635-14.481-3.053-15.736 4.922zM19.203 21.6c-0.756 1.084-1.997 1.783-3.41 1.783-2.297 0-4.152-1.855-4.152-4.152 0-2.183 1.698-3.98 3.852-4.137v0c1.341-0.057 2.597 0.671 3.181 1.84 0.642 1.27 0.414 2.825-0.599 3.881 0.385 0.271 0.756 0.528 1.127 0.785zM27.863 21.757c-2.197 4.979-6.72 7.59-11.542 7.518-9.259-0.457-11.955-11.142-5.764-14.994l0.271 0.271c-0.1 0.143-0.471 0.428-1.041 1.555-0.671 1.37-0.885 2.739-0.799 3.595 0.485 7.461 10.943 8.988 14.538 1.598 4.58-10.115-7.576-20.401-18.361-12.54l-0.243-0.243c2.839-4.451 8.389-6.434 13.682-5.107 8.089 2.040 12.44 10.472 9.259 18.347z"
            ></path>
            <path
              fill="#fff"
              style="fill: var(--color1, #fff);"
              d="M46.167 10.215v7.019c0 2.796-1.712 4.879-4.836 4.879s-4.836-2.083-4.836-4.879v-7.019h2.539v6.819c0 1.698 0.799 2.668 2.297 2.668 1.484 0 2.297-0.97 2.297-2.668v-6.819h2.539zM55.626 18.532c0 2.026-1.584 3.481-4.152 3.481h-4.052v-11.699h3.895c2.254 0 3.752 1.084 3.752 2.825 0 1.327-0.613 2.126-1.541 2.511 1.255 0.471 2.097 1.313 2.097 2.882zM49.976 12.555v2.468h1.341c0.785 0 1.327-0.457 1.327-1.241s-0.542-1.241-1.327-1.241h-1.341zM51.388 19.774c1.084 0 1.712-0.499 1.712-1.469s-0.613-1.469-1.712-1.469h-1.412v2.939h1.412zM56.624 10.315h2.539v11.699h-2.539v-11.699zM65.313 15.051c2.012 0.699 3.039 1.598 3.039 3.41 0 2.425-1.855 3.766-4.052 3.766-2.026 0-3.581-0.899-4.237-2.568l2.026-1.498c0.371 1.056 1.327 1.698 2.283 1.698 0.842 0 1.441-0.457 1.441-1.198 0-0.699-0.457-1.141-2.126-1.741-1.812-0.656-3.153-1.555-3.153-3.495 0-1.869 1.555-3.296 3.809-3.296 1.798 0 3.181 0.713 3.838 2.14l-2.026 1.398c-0.385-0.87-0.984-1.355-1.912-1.355-0.77 0-1.341 0.414-1.341 1.013 0.014 0.685 0.656 1.099 2.411 1.726zM80.977 16.164c0 3.438-2.482 6.049-5.963 6.049-3.567 0-5.963-2.554-5.963-5.65 0-2.012 0.785-3.467 1.94-4.408l-0.399-0.399c0.885-0.913 2.511-1.641 4.423-1.641 3.481 0 5.963 2.639 5.963 6.049zM78.395 16.164c0-2.111-1.341-3.638-3.381-3.638-1.184 0-2.069 0.457-2.611 1.041l0.399 0.399c-0.613 0.514-1.17 1.241-1.17 2.525 0 1.769 1.255 3.324 3.381 3.324 2.054-0.014 3.381-1.541 3.381-3.652zM84.558 12.726v2.711h4.965v1.94h-4.965v4.637h-2.539v-11.699h8.018v2.411h-5.478zM100.123 12.726h-3.281v9.288h-2.539v-9.288h-3.296v-2.411h9.116v2.411z"
            ></path>
          </svg>
        </a>
      </div>
      <div
        id="overlay-widget"
        class="globalNavigation__overlay"
        data-ccid="1OvsQVE5SioW2CMofsrqNp"
      ></div>
    </div>
    <!-- <div
      id="header-cny"
      class="header-cny"
      :class="{ show: showPic.headerCny }"
    >
      <div class="left-title">
        <img src="../assets/img/tiger_l.png" class="showindesk" /><img
          src="../assets/img/head_top.png"
          class="hideindesk"
        />
      </div>
      <div class="video-wrap">
        <video
          v-if="!isMobile"
          id=""
          class="looping-video"
          muted="muted"
          autoplay=""
          playsinline=""
          loop=""
          type="video/mp4"
          src="../assets/img/cny_loop_muted.mp4"
          poster="../assets/img/tt2.jpg"
        ></video>
        <img
          v-else
          style="
            width: 100%;
            height: 100%;
            border: 5px solid #fbf3b4;
            box-shadow: 0 0 10px #000;
            box-sizing: border-box;
          "
          src="../assets/img/tt2.jpg"
        />
        <a
          data-href="202201/jdc_cny22"
          @click="videoClickHandler('f33192q9j0v')"
        ></a>
      </div>
      <div class="right-title">
        <img src="../assets/img/tiger_r.png" class="showindesk" /><img
          src="../assets/img/head_bottom.png"
          class="hideindesk"
        />
      </div>
    </div>
    <div class="cny-dedicated">
      <div class="cny-wrap">
        <div
          id="cnysongs"
          class="cny-songs"
          :class="{ showpic: showPic.cnysongs }"
        >
          <div class="cny-songs-title">
            <img src="../assets/img/cny_list_title2.png" />
          </div>
          <p>
            *
            所有更新曲目于2022年1月21日中午12点在《舞力全开》（国行版）“舞力无限”上线
          </p>
          <div class="cny-songs-list">
            <div class="top-song song">
              <img src="../assets/img/cny_song1.jpg" />
              <p>恭喜恭喜</p>
            </div>
            <div class="sec-song song">
              <img src="../assets/img/cny_song2.jpg" />
              <p>华丽天后</p>
            </div>
            <div class="sec-song song">
              <img src="../assets/img/cny_song3.jpg" />
              <p>小苹果</p>
            </div>
            <div class="third-songs">
              <div class="third-song song">
                <img src="../assets/img/cny_song4.jpg" />
                <p>小丑</p>
              </div>
              <div class="third-song song">
                <img src="../assets/img/cny_song5.jpg" />
                <p>爱</p>
              </div>
            </div>
          </div>
        </div>
        <div
          id="jd22songs"
          class="jd22-wrap"
          :class="{ showpic: showPic.jd22wrap }"
        >
          <img src="../assets/img/cny_list_title.png" />
          <div class="video-wrap">
            <div class="video">
              <video
                v-if="!isMobile"
                class="looping-video"
                muted="muted"
                autoplay=""
                playsinline=""
                loop=""
                type="video/mp4"
                src="../assets/img/JD22_Trailer.mp4"
                poster="../assets/img/t2.jpg"
              ></video>
              <img
                v-else
                style="
                  width: 100%;
                  border-color: #df18b3;
                  border-width: 4px;
                  border-image-slice: 1;
                  border-style: solid;
                  border-radius: 20px;
                "
                src="../assets/img/JD22_Trailer.jpg"
              />
              <a
                data-href="202110/JD22_Trailer"
                @click="videoClickHandler('g33042so7e1')"
              ></a>
            </div>
          </div>
          <div class="jd22-sc" :class="{ showpic: showPic.jd22sc }">
            <ul :style="songListStyle2">
              <li
                v-for="(item, index) in list2"
                :key="index"
                :style="{ width: songListWidth2 }"
              >
                <h3>{{ item.song }}</h3>
                <p>{{ item.singer }}</p>
              </li>
            </ul>
          </div>
          <div
            v-show="showController2"
            class="controller"
            :class="{ showpic: showPic.jd22controller }"
          >
            <div class="c-l" @click="pageChange2(-1)"></div>
            <div class="dot-wrap22">
              <div
                v-for="item in pages2"
                :key="item"
                class="dot"
                :style="{ cursor: 'pointer' }"
                :class="{ active: item + 1 === currentPage2 }"
                @click="currentPage2 = item + 1"
              ></div>
            </div>
            <div class="c-r" @click="pageChange2(1)"></div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="header">
      <div class="tiebg-wrap" :class="{ active: inited }">
        <img src="../assets/img/tie.png" class="tiebg" />
      </div>
      <div class="header-bar">
        <div class="gamelogo" :class="{ animation: showPic.gameLogoAnima }">
          <img src="../assets/img/logo.png" />
        </div>
        <div class="slogon" :class="{ animation: showPic.gameLogoAnima }">
          我就这么<span>跳</span>！
          <a
            href="javascript:void(0);"
            class="demo"
            @click="
              jump(
                'https://www.nintendoswitch.com.cn/software/70010000027771',
                true
              )
            "
            >立即购买</a
          >
        </div>
      </div>

      <div class="header-wrap">
        <img
          src="../assets/img/mobile_f.png"
          class="hideindesk"
          style="width: 100%;"
        />
        <div class="top-video" :class="{ animation: showPic.topVideoAnima }">
          <video
            v-if="!isMobile"
            id=""
            class="looping-video"
            muted=""
            autoplay=""
            playsinline=""
            loop=""
            type="video/mp4"
            src="../assets/img/jdc_loop.mp4"
            poster="../assets/img/t2.jpg"
          ></video>
          <img
            v-else
            style="
              width: 100%;
              height: 100%;
              border: 5px solid #fff8cb;
              box-shadow: 0 0 10px #000;
              border-radius: 20px;
              box-sizing: border-box;
            "
            src="../assets/img/t2.jpg"
          />
          <a
            data-href="202012/JDC_Gameplay"
            @click="videoClickHandler('t3269rlxvi3')"
          ></a>
        </div>
      </div>
    </div>
    <div
      id="sc-list-3"
      class="sc-list"
      style="
        transform: rotate(4.3deg);
        transform-origin: 50% 50%;
        background: #4d1c78;
        position: relative;
      "
    >
      <ul :style="scList3Style">
        <li
          v-for="(img, index) in imgList3Show"
          :key="index"
          :style="scList3LiStyle"
        >
          <div><img :src="img" /></div>
        </li>
      </ul>
    </div>
    <div id="year2" class="jd23">
      <div class="jd23-wrap" :class="{ showpic: showPic.jd22wrap }">
        <div class="jd23-title">
          <img src="../assets/img/jd23_title.png" />
        </div>
        <div class="video-wrap">
          <div class="video">
            <video
              v-if="!isMobile"
              class="looping-video"
              muted=""
              autoplay=""
              playsinline=""
              loop=""
              type="video/mp4"
              src="../assets/img/jd23_preview.mp4"
              poster="../assets/img/jd23_22_trailer.jpg"
            ></video>
            <img
              v-else
              style="
                width: 100%;
                border-color: #df18b3;
                border-width: 4px;
                border-image-slice: 1;
                border-style: solid;
                border-radius: 20px;
              "
              src="../assets/img/jd23_22_trailer.jpg"
            />
            <a
              data-href="202110/JD22_Trailer"
              @click="videoClickHandler('p3534er1p7i')"
            ></a>
          </div>
        </div>
        <div
          class="jd23-sc"
          :class="{ showpic: showPic.jd22sc }"
          style="
            touch-action: pan-y;
            user-select: none;
            -webkit-user-drag: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          "
        >
          <ul :style="songListStyle2">
            <li
              v-for="(item, index) in list2"
              :key="index"
              :style="{ width: songListWidth2 }"
            >
              <h3>{{ item.song }}</h3>
              <p>{{ item.singer }}</p>
            </li>
            <ul style="width: 1100px; transform: translateX(0px);">
              <div class="more-song">
                <img src="../assets/img/more_song.png" />
              </div>
            </ul>
          </ul>
        </div>
        <div v-show="showController2" class="controller">
          <!-- :class="{ showpic: showPic.jd22controller }" -->

          <!-- <div class="c-l" @click="pageChange2(-1)"></div>
          <div class="dot-wrap22">
            <div
              v-for="item in pages2"
              :key="item"
              class="dot"
              :style="{ cursor: 'pointer' }"
              :class="{ active: item + 1 === currentPage2 }"
              @click="currentPage2 = item + 1"
            ></div>
          </div>
          <div class="c-r" @click="pageChange2(1)"></div> -->
          <div class="c-l"></div>
          <div class="dot-wrap22"><div class="dot active"></div></div>
          <div class="c-r"></div>
        </div>
      </div>
    </div>
    <div class="intro">
      <div
        id="sc-list-1"
        class="sc-list"
        style="transform: rotate(-4.3deg); transform-origin: 50% 50%;"
      >
        <ul :style="scList1Style">
          <li
            v-for="(img, index) in imgList1Show"
            :key="index"
            :style="scList1LiStyle"
          >
            <div><img :src="img" /></div>
          </li>
        </ul>
      </div>
      <div
        id="gameinfo"
        class="intro-info"
        :class="{ showpic: showPic.gameinfo }"
      >
        <h2>游戏介绍</h2>
        <div class="intro-content">
          <div class="intro-content-cover">
            <img src="../assets/img/game-box.png" />
          </div>
          <p>
            松松你的筋骨，释放你的舞蹈灵魂，跟着《舞力全开》这款体感音乐游戏，真正地舞动起来，让你在家中尽享欢乐。<br /><br />
            《舞力全开》包含50首中国和世界各地的热门曲目，以及一个月的“舞力无限”的免费试用，让你能游玩超过700首歌曲。<br /><br />
            你可以独自起舞，也可以带动好友和家人，最多6人一起跳舞！<br /><br />
            <span>游戏平台：Nintendo Switch</span>
            <span>开发商：育碧上海</span>
            <span>支持玩家人数：1~6人</span>
          </p>
        </div>
        <ul class="intro-feature">
          <li>
            <div>
              <img src="../assets/img/t1.png" />
              <p>
                随心畅享受700+首音乐舞蹈，用手机代替游戏手柄，增强游戏体验——得分、卡路里、分享一个也不耽误！<span
                  >*现在购买游戏即可获得一个月的免费服务体验</span
                >
              </p>
            </div>
          </li>
          <li>
            <div>
              <img src="../assets/img/t2.png" />
              <p>
                用手机代替游戏手柄，增强游戏体验，追踪卡路里消耗以及游戏得分，别忘了，还能在排行榜上即刻分享你的舞蹈表现！
              </p>
            </div>
          </li>
          <li>
            <div>
              <img src="../assets/img/t3.png" />
              <p>追踪你在享受舞蹈欢乐时的卡路里消耗，时刻保持健身动力。</p>
            </div>
          </li>
          <li>
            <div>
              <img src="../assets/img/t4.png" />
              <p>
                由专门团队精心挑选的欢乐歌曲，搭配为孩子们量身打造的活泼编舞，让小朋友们也能乐在其中。
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="songlist">
      <div
        id="sc-list-2"
        class="sc-list"
        style="transform: rotate(4.3deg); transform-origin: 50% 50%;"
      >
        <ul :style="scList2Style">
          <li
            v-for="(img, index) in imgList2Show"
            :key="index"
            :style="scList2LiStyle"
          >
            <div><img :src="img" /></div>
          </li>
        </ul>
      </div>
      <div
        id="songinfo"
        class="song-info"
        :class="{ showpic: showPic.songinfo }"
      >
        <h2 class="black">游戏歌曲</h2>
        <p>
          《舞力全开》包含50首热门曲目，收集了来自中国和世界各地最潮流音乐家们的众多作品。“舞力无限”更可以让你游玩超过700首歌曲。
        </p>
        <div class="songlist-wrap">
          <ul class="hot">
            <li>
              <img src="../assets/img/s1.jpg" />
              <h3>《最炫民族风》</h3>
              <p>凤凰传奇</p>
            </li>
            <li>
              <img src="../assets/img/s2.jpg" />
              <h3>《我的新衣》</h3>
              <p>Vava</p>
            </li>
            <li>
              <img src="../assets/img/s3.jpg" />
              <h3>《怪美的》</h3>
              <p>蔡依林</p>
            </li>
            <li>
              <img src="../assets/img/s4.jpg" />
              <h3>《火锅爽》</h3>
              <p>阿雅</p>
            </li>
            <li>
              <img src="../assets/img/s5.jpg" />
              <h3>《王妃》</h3>
              <p>萧敬腾</p>
            </li>
            <li>
              <img src="../assets/img/s6.jpg" />
              <h3>《彩虹节拍》</h3>
              <p>BDF</p>
            </li>
            <li>
              <img src="../assets/img/s7.jpg" />
              <h3>《I don't care》</h3>
              <p>Ed Sheeran & Justin Bieber</p>
            </li>
            <li>
              <img src="../assets/img/s8.jpg" />
              <h3>《Kill this love》</h3>
              <p>BLACKPINK</p>
            </li>
            <li>
              <img src="../assets/img/s9.jpg" />
              <h3>《I like it》</h3>
              <p>Cardi B,Bad Bunny & J Balvin</p>
            </li>
            <li>
              <img src="../assets/img/s10.jpg" />
              <h3>《Old town road(Remix)》</h3>
              <p>Lil Nas X Fi. Billy Ray Cyrus</p>
            </li>
          </ul>
          <div
            id="songinfoother"
            class="other"
            :class="{ showpic: showPic.songinfoother }"
          >
            <ul :style="songListStyle">
              <li
                v-for="(item, index) in list"
                :key="index"
                :style="{ width: songListWidth }"
              >
                <h3>{{ item.song }}</h3>
                <p>{{ item.singer }}</p>
              </li>
            </ul>
          </div>
          <div
            v-show="showController"
            class="controller"
            :class="{ showpic: showPic.songinfo }"
          >
            <div class="c-l" @click="pageChange(-1)"></div>
            <div class="dot-wrap">
              <div
                v-for="item in pages"
                :key="item"
                class="dot"
                :style="{ cursor: 'pointer' }"
                :class="{ active: item + 1 === currentPage }"
                @click="currentPage = item + 1"
              ></div>
            </div>
            <div class="c-r" @click="pageChange(1)"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="jdu" :class="{ showpic: showPic.jdu }">
      <div id="jdu" class="jdu-wrap">
        <h2>舞力无限</h2>
        <p>
          为你带来永不停歇的狂欢派对<span
            >每份游戏包含一个月的“舞力无限”免费试用</span
          >
        </p>
        <ul class="jdu-type">
          <li>
            <img src="../assets/img/u1.png" />
            <p>霸榜热单，经典老歌，家庭最爱，超过七百首歌曲随心享</p>
          </li>
          <li>
            <img src="../assets/img/u2.png" />
            <p>精彩纷呈、友好热情的玩家社区氛围等你一同起舞</p>
          </li>
          <li>
            <img src="../assets/img/u3.png" />
            <p>加入在线舞池，线上PK零距离</p>
          </li>
          <li class="jdu-ico"><img src="../assets/img/jdu_03.png" /></li>
        </ul>
        <div class="video-wrap">
          <div class="video">
            <video
              v-if="!isMobile"
              class="looping-video"
              muted="muted"
              autoplay=""
              playsinline=""
              loop=""
              type="video/mp4"
              src="../assets/img/JDC_cny_muted.mp4"
              poster="../assets/img/JDC_cny_trailer.jpg"
            ></video>
            <img
              v-else
              style="width: 100%; border: 4px solid #fff;"
              src="../assets/img/JDC_cny_trailer.jpg"
            />
            <a
              data-href="202102/JDC_cny_trailer"
              @click="videoClickHandler('l3269wb54rv')"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="mini-program" :class="{ showpic: showPic.mpsection }">
      <div id="mpsection" class="mp-wrap">
        <h2>微信小程序</h2>
        <p>用手机代替游戏手柄，增强游戏体验</p>
        <ul>
          <li>
            <img src="../assets/img/m2.png" />
            <p>手柄</p>
          </li>
          <li>
            <img src="../assets/img/m1.png" />
            <p>追踪分数和卡路里</p>
          </li>
          <li>
            <img src="../assets/img/m3.png" />
            <p>轻松分享你的舞蹈</p>
          </li>
        </ul>
        <div class="mp_code"><img src="../assets/img/m4.png" /></div>
      </div>
    </div>
    <div
      id="videosection"
      style="overflow-x: hidden;"
      class="new-video"
      :class="{ showpic: showPic.videosection }"
    >
      <h2 class="black">游戏视频</h2>
      <div class="video-wrap">
        <div class="video">
          <img src="../assets/img/t2.jpg" />
          <a
            data-href="202012/JDC_Gameplay"
            @click="videoClickHandler('t3269rlxvi3')"
          ></a>
        </div>
      </div>
      <div class="two-qr">
        <img src="../assets/img/wc_qr.png" class="wc" />
      </div>
      <div class="public-agetips">
        <div class="public-agetips-icon">
          <img src="../assets/img/icon-age-tips.png" alt="" />
        </div>
        <div class="popbox-agetips">
          <!-- <div class="popbox-bg"></div> -->
          <div class="popbox-dialog">
            <div class="popbox-inner">
              <div class="popbox-hd">
                <div class="popbox-hd-title">舞力全开</div>
              </div>
              <div class="popbox-bd">
                <div class="popbox-bd-infos">
                  <div class="popbox-bd-icon">
                    <img src="../assets/img/icon-age-tips.png" alt="" />
                  </div>
                  <div class="popbox-bd-texts">
                    <p>
                      1）本游戏是一款音乐体感游戏，建议年满8周岁及以上的未成年人用户在家长监护下使用游戏产品。
                    </p>
                    <p>
                      2）本游戏富含韵律与动感，舞者能够随着音乐和游戏中的指导动作翩翩起舞，画面色彩鲜艳，是一款适合所有年龄层次的体感类音乐健身游戏。
                    </p>
                    <p>
                      3）本游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理：Nintendo
                      Switch
                      e商店不支持未成年人付款。未成年人如需购买游戏，需先征求监护人同意，由监护人扫码进行支付。根据国家规定未成年人用户仅可在周五、周六、周日和法定节假日每日20时至21时使用。
                    </p>
                    <p>
                      4）本游戏中玩家需要通过挥舞手柄来进行舞蹈动作的识别，支持本地多人模式，让您可以与父母、孩子和朋友一起游玩。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          text-align: center;
          margin-top: 20px;
          position: relative;
          z-index: 10;
        "
      >
        <a
          style="color: #000; text-decoration: none; font-size: 14px;"
          href="https://game.qq.com/self-discipline_pact.shtml"
          target="_blank"
          >网络游戏行业防沉迷自律公约</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import '@/../assets/main.css';
import { pgvEventReport } from './tcss-report';
import { setTimeout, setInterval } from 'timers';
function checkVisible(elm) {
  const rect = elm.getBoundingClientRect();
  const viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  );
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}
let w =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;
const imgList1 = [
  require('@/../assets/img/1.jpg'),
  require('@/../assets/img/2.jpg'),
  require('@/../assets/img/3.jpg'),
  require('@/../assets/img/4.jpg'),
  require('@/../assets/img/5.jpg'),
  require('@/../assets/img/12.jpg'),
  require('@/../assets/img/15.jpg'),
  require('@/../assets/img/16.jpg'),
  require('@/../assets/img/20.jpg')
];
const imgList2 = [
  require('@/../assets/img/7.jpg'),
  require('@/../assets/img/8.jpg'),
  require('@/../assets/img/9.jpg'),
  require('@/../assets/img/10.jpg'),
  require('@/../assets/img/11.jpg'),
  require('@/../assets/img/13.jpg'),
  require('@/../assets/img/14.jpg'),
  require('@/../assets/img/18.jpg'),
  require('@/../assets/img/19.jpg')
];
const imgList3 = [
  require('@/../assets/img/22_1.jpg'),
  require('@/../assets/img/22_2.jpg'),
  require('@/../assets/img/22_3.jpg'),
  require('@/../assets/img/22_4.jpg'),
  require('@/../assets/img/22_5.jpg'),
  require('@/../assets/img/22_6.jpg'),
  require('@/../assets/img/22_7.jpg'),
  require('@/../assets/img/22_8.jpg'),
  require('@/../assets/img/22_9.jpg'),
  require('@/../assets/img/22_10.jpg'),
  require('@/../assets/img/22_11.jpg'),
  require('@/../assets/img/22_12.jpg')
];

export default {
  name: 'App',
  data() {
    return {
      supportwebp: true,
      currentPage: 1,
      pageNum: 1,
      pageWidth: 1100,
      pageSize: 4,
      currentPage2: 1,
      pageNum2: 1,
      pageWidth2: 1100,
      pageWidth22: 1100,
      pageSize2: 4,
      isMobile: false,
      showVideo: false,
      showPic: {
        headerActive: false,
        sloganAnima: false,
        topVideoAnima: false,
        gameLogoAnima: false,
        gameinfo: false,
        songinfo: false,
        songinfoother: false,
        jdu: false,
        mpsection: false,
        videosection: false,
        jd22wrap: false,
        jd22sc: false,
        jd22controller: false,
        headerCny: false,
        cnysongs: false
      },
      showController: true, // 动画效果，需要前置展示
      showController2: true,
      list: [
        { song: '365', singer: 'Zedd & Katy Perry' },
        { song: '7 rings', singer: 'Ariana Grande' },
        { song: 'Jungle Dances', singer: 'The Sunlight Shakers' },
        { song: 'Baby Shark', singer: 'Pinkfong' },
        { song: 'Bad Boy', singer: 'Riton & Kah-Lo' },
        { song: 'Bad guy', singer: 'Billie Eilish' },
        { song: 'Le Bal Masqué', singer: 'Dr. Creole' },
        { song: 'The Frog Concert', singer: 'Groove Century' },
        { song: 'Bangarang', singer: 'Skrillex Ft. Sirah' },
        { song: 'Bassa Sababa', singer: 'Netta' },
        { song: 'Happy Birthday', singer: 'Top Culture' },
        {
          song: 'Infernal Galop (Can-Can)',
          singer: 'The Just Dance Orchestra'
        },
        { song: 'Kitchen Kittens', singer: 'Cooking Meow Meow' },
        { song: 'Con Altura', singer: 'ROSALÍA & J Balvin Ft. El Guincho' },
        { song: 'Con Calma', singer: 'Daddy Yankee Ft. Snow' },
        { song: 'Só Depois Do Carnaval', singer: 'Lexa' },
        { song: "Everybody (Backstreet's Back)", singer: 'Millennium Alert' },
        { song: 'FANCY', singer: 'TWICE' },
        { song: 'Freeze Please', singer: 'The Just Dance School' },
        { song: 'Get Busy', singer: 'KOYOTIE' },
        { song: 'God Is A Woman', singer: 'Ariana Grande' },
        { song: 'High Hopes', singer: 'Panic! At The Disco' },
        { song: 'I Am The Best', singer: '2NE1' },
        { song: 'Just An Illusion', singer: 'Equinox Stars' },
        { song: 'Keep In Touch', singer: 'JD McCrary' },
        { song: 'MA ITU', singer: 'Stella Mwangi' },
        { song: 'My Friend The Dragon', singer: 'The Just Dance Orchestra' },
        { song: 'Policeman', singer: 'Eva Simons Ft. Konshens' },
        { song: 'Rain Over Me', singer: 'Pitbull Ft. Marc Anthony' },
        { song: 'Mini Yo School', singer: 'Dancing Bros.' },
        { song: 'Skibidi', singer: 'Little Big' },
        { song: 'Soy Yo', singer: 'Bomba Estéreo' },
        { song: "Stop Movin'", singer: 'Royal Republic' },
        { song: 'Sushi', singer: 'Merk & Kremont' },
        {
          song: 'Taki Taki',
          singer: 'DJ Snake Ft. Selena Gomez, Ozuna, Cardi B'
        },
        { song: 'Talk', singer: 'Khalid' },
        { song: 'Tel Aviv', singer: 'Omer Adam Ft. Arisa' },
        { song: 'The Time (Dirty Bit)', singer: 'Black Eyed Peas' },
        { song: 'Vodovorot', singer: 'XS Project' },
        { song: 'Magical Morning', singer: 'The Just Dance Orchestra' }
      ],
      list2: [
        { singer: 'The Just Dancers', song: 'If You Wanna Party' },
        { singer: 'Justin Timberlake', song: "CAN'T STOP THE FEELING!" },
        { singer: 'The Trammps', song: 'Disco Inferno' },
        { singer: 'Apashe ft. Wasiu', song: 'Majesty' },
        { singer: 'KDA', song: 'More' },
        { singer: 'Glass Animals', song: 'Heat Waves' }
      ],
      imgList1,
      imgList1Show: imgList1.concat(imgList1),
      imgList1Width: 540,
      imgList1X: 0,
      imgList1Speed: 0.8,
      imgList2,
      imgList2Show: imgList2.concat(imgList2),
      imgList2Width: 540,
      imgList2X: 0,
      imgList2Speed: 0.8,
      imgList3,
      imgList3Show: imgList3.concat(imgList3),
      imgList3Width: 540,
      imgList3X: 0,
      imgList3Speed: 0.8,
      videoHeight: 0,
      inited: false
    };
  },
  computed: {
    autoFixVideoStyle() {
      return {
        width: '100%',
        height: `${this.videoHeight}px`,
        // marginTop: this.isMobile ? '50%' : 0,
        maxHeight: '99vh'
      };
    },
    songListStyle() {
      return {
        transform: `translatex(-${(this.currentPage - 1) * this.pageWidth}px)`,
        width: `${this.pageWidth * this.pageNum}px`
      };
    },
    songListStyle2() {
      return {
        transform: `translatex(-${
          (this.currentPage2 - 1) * this.pageWidth2
        }px)`,
        width: `${this.pageWidth2 * this.pageNum2}px`
      };
    },
    pages() {
      return Array.from(Array(this.pageNum).keys());
    },
    pages2() {
      return Array.from(Array(this.pageNum2).keys());
    },
    songListWidth() {
      return `${this.pageWidth / this.pageSize}px`;
    },
    songListWidth2() {
      return `${this.pageWidth2 / this.pageSize2}px`;
    },
    scList1Style() {
      return {
        width: `${2 * this.imgList1.length * this.imgList1Width}px`,
        transform: `translateX(${this.imgList1X}px)`
      };
    },
    scList1LiStyle() {
      return {
        width: `${this.imgList1Width}px`
      };
    },
    scList2Style() {
      return {
        width: `${2 * this.imgList2.length * this.imgList2Width}px`,
        transform: `translateX(${
          w - 2 * this.imgList2.length * this.imgList2Width + this.imgList2X
        }px)`
      };
    },
    scList2LiStyle() {
      return {
        width: `${this.imgList2Width}px`
      };
    },
    scList3Style() {
      return {
        width: `${2 * this.imgList3.length * this.imgList3Width}px`,
        transform: `translateX(${
          w - 2 * this.imgList3.length * this.imgList3Width + this.imgList3X
        }px)`
      };
    },
    scList3LiStyle() {
      return {
        width: `${this.imgList3Width}px`
      };
    }
  },
  created() {
    if (this.$wxSdk) {
      this.$wxSdk.updateShareData({
        title: '舞力全开｜育碧游戏',
        desc: '舞力全开，无限畅跳',
        shareLink: window.location.href.replace(window.location.hash, ''),
        imgUrl: 'https://switch-cn.gtgres.com/justdance/share.jpg'
      });
    }
    this.checkSupportWebp();
    const showObj = () => {
      // if (checkVisible(document.getElementById('header-cny'))) {
      //   setTimeout(() => {
      //     this.showPic.headerCny = true;
      //   }, 500);
      // }
      // if (checkVisible(document.getElementById('cnysongs'))) {
      //   setTimeout(() => {
      //     this.showPic.cnysongs = true;
      //   }, 500);
      // }
      if (checkVisible(document.getElementById('gameinfo'))) {
        setTimeout(() => {
          this.showPic.gameinfo = true;
        }, 500);
      }
      if (checkVisible(document.getElementById('songinfo'))) {
        setTimeout(() => {
          this.showPic.songinfo = true;
        }, 500);
      }
      if (checkVisible(document.getElementById('songinfoother'))) {
        setTimeout(() => {
          this.showPic.songinfoother = true;
          this.$nextTick(() => {
            this.resizeCommonWindow();
          });
        }, 500);
      }
      if (checkVisible(document.getElementById('jdu'))) {
        setTimeout(() => {
          this.showPic.jdu = true;
        }, 500);
      }
      if (checkVisible(document.getElementById('mpsection'))) {
        setTimeout(() => {
          this.showPic.mpsection = true;
        }, 500);
      }
      if (checkVisible(document.getElementById('videosection'))) {
        setTimeout(() => {
          this.showPic.videosection = true;
        }, 500);
      }
      if (checkVisible(document.getElementById('year2'))) {
        setTimeout(() => {
          this.showPic.jd22wrap = true;
        }, 500);
        setTimeout(() => {
          this.showPic.jd22sc = true;
          this.showPic.jd22controller = true;
          this.$nextTick(() => {
            this.resizeCommonWindow();
          });
        }, 1000);
      }
    };
    window.onscroll = () => {
      showObj();
    };
    window.onresize = () => {
      w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      this.resizeCommonWindow();
      this.setVideoHeight();
    };
    this.showObj = showObj;
  },
  mounted() {
    this.setVideoHeight();
    const ua = navigator.userAgent;
    this.isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mi\s|mix\s|redmi/i.test(
      ua
    );
    setTimeout(() => {
      this.showPic.sloganAnima = true;
      this.showPic.topVideoAnima = true;
    }, 1000);
    // setTimeout(() => {
    //   this.showPic.headerActive = true;
    // });
    setTimeout(() => {
      this.showPic.gameLogoAnima = true;
    }, 400);
    this.imgList1Width = 540;
    this.imgList1Speed = 0.8;
    this.imglist1Interval = setInterval(() => {
      if (this.imgList1X * -1 > this.imgList1.length * this.imgList1Width) {
        this.imgList1X = 0;
      } else {
        this.imgList1X -= this.imgList1Speed;
      }
    }, 10);
    this.imgList2Width = 540;
    this.imgList2Speed = 0.8;
    this.imglist2Interval = setInterval(() => {
      if (this.imgList2X > this.imgList2.length * this.imgList2Width) {
        this.imgList2X = 0;
      } else {
        this.imgList2X += this.imgList2Speed;
      }
    }, 10);
    this.imgList3Width = 540;
    this.imgList3Speed = 0.8;
    setInterval(() => {
      if (this.imgList3X > this.imgList3.length * this.imgList3Width) {
        this.imgList3X = 0;
      } else {
        this.imgList3X += this.imgList3Speed;
      }
    }, 10);
    this.resizeCommonWindow();
    this.showObj();
    this.inited = true;
  },
  methods: {
    checkSupportWebp() {
      const _this = this;
      const img = new Image();
      img.onload = function () {
        const result = img.width > 0 && img.height > 0;
        _this.supportwebp = result;
      };
      img.onerror = function () {
        _this.supportwebp = false;
      };
      img.src =
        'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
    },
    setVideoHeight() {
      // 计算视频高度，保持比例 1920/1080
      const vWidth = document.getElementById('videobox').offsetWidth;
      this.videoHeight = (1080 / 1920) * vWidth;
    },
    resizeCommonWindow() {
      if (w > 1280) {
        this.pageWidth = 1100;
        // 歌曲表展示1页=全部展示 展示4列
        this.pageNum = 1;
        this.pageSize = 4;
        this.showController = false;
        // 另一个列表展示2页，4列
        this.pageWidth2 = 1100;
        this.pageNum2 = 1;
        this.pageSize2 = 4;
        this.showController2 = true;
      } else if (w > 640) {
        // 歌曲表展示2页 展示3列一页
        this.pageWidth = document.querySelector(
          '.songlist-wrap .other'
        ).offsetWidth;
        this.pageNum = 2;
        this.pageSize = 3;
        this.showController = true;
        // 另一个列表展示3页，3列
        this.pageWidth2 = document.querySelector('.jd23-sc').offsetWidth - 100;
        this.pageNum2 = 1;
        this.pageSize2 = 3;
        this.showController2 = true;
      } else {
        // 歌曲表展示4页 展示2列一页
        // this.pageWidth = document.querySelector(
        //   '.songlist-wrap .other'
        // ).offsetWidth;
        this.pageWidth = Math.ceil(document.body.offsetWidth * 0.9);
        this.pageNum = 4;
        this.pageSize = 2;
        this.showController = true;
        // 另一个列表展示4页，2列
        // this.pageWidth2 = document.querySelector('.jd22-sc').offsetWidth;
        this.pageWidth2 = Math.ceil(document.body.offsetWidth * 0.9);
        this.pageNum2 = 1;
        this.pageSize2 = 2;
        this.showController2 = true;
        // console.log('1', this.pageWidth, this.pageNum, this.pageSize);
        // console.log('2', this.pageWidth2, this.pageNum2, this.pageSize2);
      }
      if (this.currentPage > this.pageNum) {
        this.currentPage = this.pageNum;
      }
      if (this.currentPage2 > this.pageNum2) {
        this.currentPage2 = this.pageNum2;
      }
      if (w > 640) {
        if (this.imgList1Width !== 540) {
          this.imgList1Width = 540;
        }
        if (this.imgList2Width !== 540) {
          this.imgList2Width = 540;
        }
        if (this.imgList3Width !== 540) {
          this.imgList3Width = 540;
        }
      } else {
        this.imgList1Width = w * 0.7;
        this.imgList2Width = w * 0.7;
        this.imgList3Width = w * 0.7;
      }
    },
    pageChange(num) {
      this.currentPage = this.currentPage + num;
      if (this.currentPage <= 0) {
        this.currentPage = 1;
      }
      if (this.currentPage >= this.pageNum) {
        this.currentPage = this.pageNum;
      }
    },
    pageChange2(num) {
      this.currentPage2 = this.currentPage2 + num;
      if (this.currentPage2 <= 0) {
        this.currentPage2 = 1;
      }
      if (this.currentPage2 >= this.pageNum2) {
        this.currentPage2 = this.pageNum2;
      }
    },
    videoClickHandler(vid) {
      pgvEventReport(`justdance.main.playvideo.${vid}`);
      document.body.style.overflowY = 'hidden';
      document.body.style.height = '100vh';
      this.showVideo = true;
      this.$nextTick(() => {
        this.setVideoHeight();
      });
      new Txplayer({
        containerId: 'videobox',
        vid,
        width: '100%',
        height: '100%',
        autoplay: true,
        platform: '5410201',
        sdtfrom: 'v1012',
        miniSkinAdaptive: false
      });
    },
    closeVideo() {
      this.showVideo = false;
      document.body.style.overflowY = 'auto';
      document.body.style.height = 'unset';
      document.getElementById('videobox').innerHTML = '';
    },
    jump(url, blank) {
      pgvEventReport(`justdance.main.jump.${url}`);
      if (blank) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    preventMove(e) {
      e.preventDefault();
    }
  }
};
</script>
<style>
.logo_switch_top {
  background: url(//switch-cn.gtgres.com/switch/aabpa/assets/images/common/logo_switch.png)
    no-repeat 0 0;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  text-indent: -9999px;
  width: 80px;
  height: 80px;
  z-index: 99;
}
.logo_switch_top a {
  display: block;
  width: 100%;
  height: 100%;
}
@media (max-width: 759px) {
  .logo_switch_top {
    width: 80px;
    height: 80px;
    background-size: 80px auto;
  }
}
@media (min-width: 760px), print {
  .logo_switch_top {
    width: 80px;
    height: 80px;
    background-size: 80px auto;
  }
}
</style>
